// extracted by mini-css-extract-plugin
export default {"kpi_table_container":"kpiTable_kpi_table_container__CuXTO","last_row_total":"kpiTable_last_row_total__QGCvW"};